import { Language } from '../context/LanguageContext';

interface FluoringTranslations {
    mainTitle: string;
    mainSubtitle: string;
    fluorTitle: string;
    fluorSubtitle: string;
    fluorDescription: string;
    messageTitle: string;
    messageSubtitle: string;
    messageDescription: string;
    eternityTitle: string;
    eternitySubtitle: string;
    eternityDescription: string;
    collectionItems: Array<{
        id: number;
        name: string;
        description: string;
        image: string;
    }>;
}

export const fluoringTemplateTranslations: Record<Language, FluoringTranslations> = {
    en: {
        mainTitle: "THE HIDDEN MESSAGES",
        mainSubtitle: "FROM INSIDE",
        fluorTitle: "FLUORESCENT",
        fluorSubtitle: "INITIALS",
        fluorDescription: "By placing natural fluorescent diamonds as script, you can embed a hidden message, like the names of two people in love, or a symbol. The message becomes visible only when the ring is exposed to UV light.",
        messageTitle: "THE MESSAGE",
        messageSubtitle: "FROM INSIDE",
        messageDescription: "The truth is hidden and is deep within. It shows its face only in specific circumstances. But in reality it is always there.",
        eternityTitle: "ETERNITY",
        eternitySubtitle: "RING",
        eternityDescription: "A ring always is a symbol of what you feel connected to. By giving it a specific direction, you can focus it and strengthen the connection.",
        collectionItems: [
            {
                id: 1,
                name: "ETERNITY RING 8MM",
                description: "2.27 ct",
                image: "/images/jewellery_fluoring_grid_1_mini.png"
            },
            {
                id: 2,
                name: "ETERNITY RING 9.5MM",
                description: "3.28 ct",
                image: "/images/jewellery_fluoring_grid_2_medi.png"
            },
            {
                id: 3,
                name: "ETERNITY RING 10MM",
                description: "3.84 ct",
                image: "/images/jewellery_fluoring_grid_3_maxi.png"
            }
        ]
    },
    de: {
        mainTitle: "DIE VERSTECKTEN BOTSCHAFTEN",
        mainSubtitle: "AUS DEM INNEREN",
        fluorTitle: "FLUORESZIERENDE",
        fluorSubtitle: "INITIALEN",
        fluorDescription: "Indem wir natürlich fluoreszierende Diamanten als Schriftzug einsetzen, können Sie eine versteckte Botschaft in die Ringe einbetten, z. B. die Namen zweier verliebter Menschen oder ein Symbol. Die Botschaft wird erst sichtbar, wenn der Ring mit UV-Licht bestrahlt wird.",
        messageTitle: "DIE NACHRICHT",
        messageSubtitle: "AUS DEM INNEREN",
        messageDescription: "Eine Botschaft die verborgen ist und sich nur unter bestimmten Umständen offenbart. Doch sowohl die Botschaft wie auch deren Bedeutung ist immer vorhanden.",
        eternityTitle: "ETERNITY",
        eternitySubtitle: "RING",
        eternityDescription: "Ein Ring ist immer ein Symbol für das, womit man sich verbunden fühlt. Indem man ihm eine bestimmte Bedeutung gibt, richtet man den Fokus auf deren Ursprung und stärkt die Verbindung.",
        collectionItems: [
            {
                id: 1,
                name: "ETERNITY RING 8MM",
                description: "2.27 ct",
                image: "/images/jewellery_fluoring_grid_1_mini.png"
            },
            {
                id: 2,
                name: "ETERNITY RING 9.5MM",
                description: "3.28 ct",
                image: "/images/jewellery_fluoring_grid_2_medi.png"
            },
            {
                id: 3,
                name: "ETERNITY RING 10MM",
                description: "3.84 ct",
                image: "/images/jewellery_fluoring_grid_3_maxi.png"
            }
        ]
    }
}; 